import React from 'react'
import i18next from 'i18next'
import {Icon} from '@/components/dumb/Icon'
import {MenuDataItemWithProduct} from '@/stores/auth/types/MenuDataItemWithProduct'
import {routesProductsMap} from '@/router/routes-products-map'
import {USER_GUIDE_SELECTORS} from '@/constants'
import {urls} from '@/constants/urls'

import {ROUTES} from './routes'
import {routesPermissionMap} from './routes-permission-map'

export const menu: () => MenuDataItemWithProduct[] = () =>
    ([] = [
        {
            icon: <Icon type='home' />,
            title: i18next.t('globals:pages.overview'),
            path: ROUTES.home,
            permissions: routesPermissionMap[ROUTES.home],
            products: routesProductsMap[ROUTES.home],
            className: USER_GUIDE_SELECTORS.overview
        },
        {
            icon: <Icon type='payments' />,
            title: i18next.t('globals:pages.payments'),
            path: ROUTES.payments,
            children: [
                {
                    title: i18next.t('globals:pages.posPayments'),
                    path: ROUTES.posPayments,
                    permissions: routesPermissionMap[ROUTES.posPayments],
                    products: routesProductsMap[ROUTES.posPayments],
                    className: USER_GUIDE_SELECTORS.posPayments
                },
                {
                    title: i18next.t('globals:pages.onlinePayments'),
                    path: ROUTES.onlinePayments,
                    permissions: routesPermissionMap[ROUTES.onlinePayments],
                    products: routesProductsMap[ROUTES.onlinePayments],
                    className: USER_GUIDE_SELECTORS.onlinePayments
                },
                {
                    title: i18next.t('globals:pages.paymentLinks'),
                    path: ROUTES.paymentLinks,
                    permissions: routesPermissionMap[ROUTES.paymentLinks],
                    products: routesProductsMap[ROUTES.paymentLinks],
                    className: USER_GUIDE_SELECTORS.paymentLinks
                },
                {
                    title: i18next.t('globals:pages.virtualTerminal'),
                    path: ROUTES.virtualTerminal,
                    permissions: routesPermissionMap[ROUTES.virtualTerminal],
                    products: routesProductsMap[ROUTES.virtualTerminal],
                    className: USER_GUIDE_SELECTORS.virtualTerminal
                },
                {
                    title: i18next.t('globals:pages.posAmexPayments'),
                    path: ROUTES.posAmexPayments,
                    permissions: routesPermissionMap[ROUTES.posAmexPayments],
                    products: routesProductsMap[ROUTES.posAmexPayments],
                    className: USER_GUIDE_SELECTORS.posAmexPayments
                }
            ]
        },
        {
            icon: <Icon type='chargebacks' />,
            title: i18next.t('globals:pages.chargebacks'),
            path: ROUTES.chargebacks,
            permissions: routesPermissionMap[ROUTES.chargebacks],
            products: routesProductsMap[ROUTES.chargebacks],
            className: USER_GUIDE_SELECTORS.chargebacks
        },
        {
            icon: <Icon type='settlements' />,
            title: i18next.t('globals:pages.settlements'),
            permissions: routesPermissionMap[ROUTES.settlements.perTransactionDate],
            products: routesProductsMap[ROUTES.settlements.perTransactionDate],
            path: ROUTES.settlements.base,
            children: [
                {
                    title: i18next.t('globals:pages.perSettlementDate'),
                    path: ROUTES.settlements.perSettlementDate,
                    permissions: routesPermissionMap[ROUTES.settlements.perSettlementDate],
                    products: routesProductsMap[ROUTES.settlements.perSettlementDate]
                },
                {
                    title: i18next.t('globals:pages.perTransactionDate'),
                    path: ROUTES.settlements.perTransactionDate,
                    permissions: routesPermissionMap[ROUTES.settlements.perTransactionDate],
                    products: routesProductsMap[ROUTES.settlements.perTransactionDate],
                    className: USER_GUIDE_SELECTORS.settlements
                }
            ]
        },
        {
            icon: <Icon type='dccMenu' />,
            title: i18next.t('globals:pages.dcc'),
            path: ROUTES.dcc,
            permissions: routesPermissionMap[ROUTES.dcc],
            products: routesProductsMap[ROUTES.dcc],
            className: USER_GUIDE_SELECTORS.dcc
        },
        {
            icon: <Icon type='referAFriend' className='refer-a-friend-menu-icon' />,
            title: i18next.t('globals:pages.referAFriend'),
            path: ROUTES.referAFriend,
            permissions: routesPermissionMap[ROUTES.referAFriend],
            products: routesProductsMap[ROUTES.referAFriend],
            className: USER_GUIDE_SELECTORS.referAFriend
        },
        {
            icon: <Icon type='digitalReceipts' className='menu-icon-featured' />,
            title: i18next.t('globals:pages.smartReceipts'),
            path: ROUTES.digitalReceipts,
            permissions: routesPermissionMap[ROUTES.digitalReceipts],
            products: routesProductsMap[ROUTES.digitalReceipts],
            className: USER_GUIDE_SELECTORS.digitalReceipts,
            menuItemClassName: 'menu-item-featured'
        },
        {
            icon: <Icon type='zash' />,
            title: i18next.t('globals:pages.zashEpos'),
            path: ROUTES.zashEpos,
            permissions: routesPermissionMap[ROUTES.zashEpos],
            products: routesProductsMap[ROUTES.zashEpos],
            className: USER_GUIDE_SELECTORS.zashEpos
        },
        {
            icon: <Icon type='settlements' />,
            title: i18next.t('globals:pages.billing'),
            permissions: routesPermissionMap[ROUTES.billing.invoices],
            products: routesProductsMap[ROUTES.billing.invoices],
            path: ROUTES.billing.base,
            children: [
                {
                    title: i18next.t('globals:pages.invoices'),
                    path: ROUTES.billing.invoices,
                    permissions: routesPermissionMap[ROUTES.billing.invoices],
                    products: routesProductsMap[ROUTES.billing.invoices],
                    className: USER_GUIDE_SELECTORS.invoices
                }
            ]
        },
        {
            icon: <Icon type='reports' />,
            title: i18next.t('globals:pages.reports'),
            path: ROUTES.reports,
            permissions: routesPermissionMap[ROUTES.reports],
            products: routesProductsMap[ROUTES.reports],
            className: USER_GUIDE_SELECTORS.reports
        },
        {
            icon: <Icon type='download' />,
            title: i18next.t('globals:pages.exports'),
            path: ROUTES.exports,
            permissions: routesPermissionMap[ROUTES.exports],
            products: routesProductsMap[ROUTES.exports],
            className: USER_GUIDE_SELECTORS.exports
        },
        {
            icon: <Icon type='settings' />,
            title: i18next.t('globals:pages.settings'),
            path: ROUTES.settings.base,
            permissions: routesPermissionMap[ROUTES.settings.base],
            products: routesProductsMap[ROUTES.settings.base],
            className: USER_GUIDE_SELECTORS.settings
        },
        {
            icon: <Icon type='help' />,
            title: i18next.t('globals:pages.help'),
            path: urls.faq
        }
    ])
